import { Badge, BadgeProps, Tooltip } from "@mantine/core"
import { useTranslation } from "react-i18next"

const COLORS: Record<string, BadgeProps["color"]> = {
  // Operational / external factors → indigo
  WEATHER:                 "indigo",
  VEHICLE_BREAKDOWN:       "indigo",
  DRIVER_INCAPACITATED:    "indigo",
  SECURITY_INCIDENT:       "indigo",
  CUSTOMS_HOLD:            "indigo",
  MISSED_TIME_WINDOW:      "indigo",
  // Quality / goods issues → red
  DAMAGED_GOODS:           "red",
  WRONG_GOODS:             "red",
  PAYMENT_FAILED:          "red",
  ID_VERIFICATION_FAILED:  "red",
  // Recipient / access issues → orange
  NO_RESPONSE:             "orange",
  RECIPIENT_REFUSED:       "orange",
  WRONG_ADDRESS:           "orange",
  ADDRESS_NOT_FOUND:       "orange",
  RECIPIENT_NOT_AVAILABLE: "orange",
  ACCESS_BLOCKED:          "orange",
  // Misc → gray
  PARTIAL_DELIVERY:        "gray",
  RESCHEDULE_REQUESTED:    "gray",
  OTHER:                   "gray",
}

const MAX_LABEL_LENGTH = 25

interface Props {
  type: string | null | undefined
  size?: BadgeProps["size"]
}

export function ExceptionTypeBadge({ type, size = "sm" }: Props) {
  const { t } = useTranslation("delivery")
  if (!type) {
    return (
      <Badge size={size} variant="outline" color="gray">
        —
      </Badge>
    )
  }

  const label = t(`failed.exType.${type}`, { defaultValue: type })
  const color = COLORS[type] ?? "gray"
  const truncated = label.length > MAX_LABEL_LENGTH ? label.slice(0, MAX_LABEL_LENGTH - 1) + "…" : label

  const badge = (
    <Badge size={size} variant="outline" color={color}>
      {truncated}
    </Badge>
  )

  if (label.length > MAX_LABEL_LENGTH) {
    return <Tooltip label={label}>{badge}</Tooltip>
  }

  return badge
}
